module.exports = __webpack_public_path__ + "img/scoreboard-overlay-2.16d12e4f.png";